import React, { ComponentPropsWithoutRef, ComponentPropsWithRef, ReactElement } from 'react';
import { ButtonGroup as USWDSButtonGroup } from '@ver-uds/uswds-react';
import Button from '../Button';

type USWDSButtonGroupProps = ComponentPropsWithoutRef<typeof USWDSButtonGroup>;
type ButtonProps = ComponentPropsWithRef<typeof Button>;

export interface ButtonGroupProps extends Omit<USWDSButtonGroupProps, 'children'> {
  children: ReactElement<ButtonProps>[];
}

const ButtonGroup = ({ children, ...rest }: ButtonGroupProps): JSX.Element => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <USWDSButtonGroup {...rest}>{children as USWDSButtonGroupProps['children']}</USWDSButtonGroup>
);

export default ButtonGroup;
